import React from "react";
import "./Home.css";
import aboutimg1 from "../assets/img/about_image.png";
import teamImg4 from "../assets/img/balbir_singh.jpg";
import teamImg3 from "../assets/img/Ankur_Kaushik.jpg";
import teamImg2 from "../assets/img/ashutosh_.jpeg";
import teamImg6 from "../assets/img/Ankit.jpg";
import teamImg1 from "../assets/img/akash_kaushik.jpg";
import teamImg5 from "../assets/img/rajesh.jpg";
import aboutbannerImage from "../assets/img/about-banner.jpg";
import { Director } from "./Director";

export const AboutUs = () => {
  return (
    <>
      {/* About Us Carousel */}
      <div className="about-carousel">
        <div className="about-carousel-inner">
          <div className="about-carousel-item">
            <img src={aboutbannerImage} alt="About Banner" />
            <div className="about-carousel-content">
              <h2>Who We Are</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="about">


        {/* About Us Content */}
        <div className="about-container">
          <span><b>Welcome to Earthy Fusion Private Limited, your trusted exporter of high-quality agricultural commodities from India</b></span>

          <div className="about-div1">

            <div className="contents-div1">

              <p>
                {/* Incorporated in 2023, Earthy Fusion Private Limited has rapidly
                emerged as a key player in India's agro commodity export market.
                Despite being a new entrant, the company has demonstrated
                impressive growth in turnover, thanks to its focus on quality,
                sustainability, and strong relationships with both Indian
                farmers and global buyers. Earthy Fusion specializes in
                exporting a diverse range of agro products, including grains,
                pulses, spices, fruits, and vegetables. By ensuring strict
                quality control and adhering to international standards, the
                company has quickly gained the trust of customers worldwide. The
                company is deeply committed to supporting sustainable farming
                practices and providing fair compensation to Indian farmers,
                ensuring a reliable and ethical supply chain. With efficient
                logistics and a focus on timely delivery, Earthy Fusion is
                making its mark on the global stage, showcasing the richness of
                India’s agricultural products to the world. */}
                Earthy Fusion Private Limited has rapidly emerged as a key player in India's agro commodity export market. The company has demonstrated impressive growth in turnover, thanks to its focus on quality, sustainability, and strong relationships with both Indian farmers and global buyers. Earthy Fusion specializes in exporting a diverse range of agro products, including grains, pulses, spices, fruits, and vegetables. By ensuring strict quality control and adhering to international standards, the company has quickly gained the trust of customers worldwide. The company is deeply committed to supporting sustainable farming practices and providing fair compensation to Indian farmers, ensuring a reliable and ethical supply chain. With efficient logistics and a focus on timely delivery, Earthy Fusion is making its mark on the global stage, showcasing the richness of India’s agricultural products to the world.
              </p>
              <p>The journey of growth began with Earthy Fusion Private Limited, a company driven by ambition and innovation. Established in the vibrant city of Jaipur, Rajasthan, the company is guided by the leadership of Akash Kaushik and Ankur Kaushik. Their commitment to excellence and expansion has propelled Earthy Fusion to new heights within the import-export sector.</p>

            </div>
            <div className="img-div1">
              <img src={aboutimg1} alt="About Us Image" />
            </div>
          </div>
          <p className="about-outer">
            Focused on achieving remarkable business milestones through a strong dedication to quality and diverse offerings, Earthy Fusion has solidified its position as a reliable and respected name in the industry. The company started with a focus on trading essential products like oilseeds, Indian spices, dehydrated goods, pulses, and more, and has continually evolved to meet the needs of a growing global market.
          </p>
          <p className="about-outer">
            Earthy Fusion has expanded its scope through strategic supply chain management, ensuring smooth transitions from vendor to customer while maintaining a high level of quality control. The company's foundation rests on values of trust, authenticity, and a strong reputation. Their ongoing success is driven by a steadfast adherence to principles of integrity, excellence, and the building of long-lasting, mutually beneficial relationships with customers, farmers, manufacturers, and suppliers.
          </p>
        </div>
        {/* <Director /> */}

        {/* Team Section */}
        <div className="team-container">
          <div className="section-header ">
            <h3>Our Team</h3>

            <div className="line-mf"></div>

            {/* <p>More over 80,000+ happy students</p> */}
          </div>
          <p className="about-outer">
            Both our supply chain partners and business collaborators have played a pivotal role in strengthening Earthy Fusion Private Limited’s foundation. We are fortunate to have a team of experienced professionals who bring years of expertise to provide a wide array of import-export solutions to our customers.</p>
          <p className="about-outer">Our leadership is committed to offering transparency, dependability, and consistent quality. We prioritize customer satisfaction by delivering products with unmatched excellence and reliability. Meeting the unique product needs of our clients and ensuring their expectations are exceeded is at the heart of our operations.</p>
          <p className="about-outer">Furthermore, our logistics network ensures seamless communication with clients, reinforcing a customer-centric approach while offering prompt deliveries within the promised timeframes

          </p>

          {/* <div className="team-title">
            <h2>Our Team</h2>
          </div> */}
          <div className="team-content">
            <div className="team-card">
              <img alt="Akash Kaushik" src={teamImg1} />
              <div className="ts-team-content">
                <h3 className="team-name">Akash Kaushik</h3>
                <p className="team-designation">Founder & CEO</p>
                {/* <div className="team-social-icons">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="mailto:Info@earthyfusionpvtltd.com"
                  >
                    <i className="fa fa-envelope"></i>
                  </a>
                </div> */}
              </div>
            </div>

            <div className="team-card">
              <img alt="Ashutosh Bansal" src={teamImg2} />
              <div className="ts-team-content">
                <h3 className="team-name">Ashutosh Bansal</h3>
                <p className="team-designation">Executive Director</p>
                {/* <div className="team-social-icons">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="mailto:Info@earthyfusionpvtltd.com"
                  >
                    <i className="fa fa-envelope"></i>
                  </a>
                </div> */}
              </div>
            </div>

            <div className="team-card">
              <img alt="Mohit Jain" src={teamImg3} />
              <div className="ts-team-content">
                <h3 className="team-name">Ankur Kaushik</h3>
                <p className="team-designation">Sales & Marketing</p>
                {/* <div className="team-social-icons">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="mailto:Info@earthyfusionpvtltd.com"
                  >
                    <i className="fa fa-envelope"></i>
                  </a>
                </div> */}
              </div>
            </div>

            <div className="team-card">
              <img alt="Balveer Kaswan" src={teamImg4} />
              <div className="ts-team-content">
                <h3 className="team-name">Balbir Kaswan</h3>
                <p className="team-designation">
                  (MSC Agriculture) Quality Control Head
                </p>
                {/* <div className="team-social-icons">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="mailto:Info@earthyfusionpvtltd.com"
                  >
                    <i className="fa fa-envelope"></i>
                  </a>
                </div> */}
              </div>
            </div>
            <div className="team-card">
              <img alt="Rajesh Gupta" src={teamImg5} />
              <div className="ts-team-content">
                <h3 className="team-name">Rajesh Gupta</h3>
                <p className="team-designation">
                  Marketing And communication Head
                </p>
                {/* <div className="team-social-icons">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="mailto:Info@earthyfusionpvtltd.com"
                  >
                    <i className="fa fa-envelope"></i>
                  </a>
                </div> */}
              </div>
            </div>
            <div className="team-card">
              <img alt="Ankit Agarwal" src={teamImg6} />
              <div className="ts-team-content">
                <h3 className="team-name">Ankit Agarwal</h3>
                <p className="team-designation">Logistics And Shipment</p>
                {/* <div className="team-social-icons">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="mailto:Info@earthyfusionpvtltd.com"
                  >
                    <i className="fa fa-envelope"></i>
                  </a>
                </div> */}
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};
